import { Component, OnInit, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'app-json-diff',
  template: require('./json-diff.component.html'),
  styles: [require('./json-diff.component.sass')]
})
export class JsonDiffComponent  extends UpgradeComponent {

    @Input() left: any;
    @Input() right: any;
    @Input() ignoreFields: string[];

    // TODO this is an angularJS component upgraded to Angular component
    constructor(elementRef: ElementRef, injector: Injector) {
      super('jsonDiffDir', elementRef, injector);
    }

}
